import { styled } from 'styled-components';

import { Media } from '../../../theme/Media.tsx';

export const Wrapper = styled.div<{ $isCollapsedNav: boolean }>`
  top: 0;
  height: 100vh;
  z-index: 10;
  transition: transform 0.3s;
  @media ${Media.lgMin} {
    position: sticky;
  }
  @media ${Media.mdMax} {
    position: fixed;
    left: 0;
    transform: translateX(${({ $isCollapsedNav }) => ($isCollapsedNav ? '-100%' : 0)});
  }
  @media ${Media.xsMax} {
    width: 100vw;
  }
`;
